import "./NewsDetailViewCustomizerDialog.scss";
import NewsContentTypes from "@/components/News/NewsContentTypes/NewsContentTypes.vue";
import draggable from "vuedraggable";
import { getDefaultContentTypes } from "@/helpers/newsHelper";

export default {
  name: "NewsDetailViewCustomizerDialog",
  props: ["customizeDialog", "images", "principalEdit", "contentTypes"],
  components: {
    draggable,
    NewsContentTypes
  },
  data: function() {
    return {
      defaultMobileBreakpoint: 600,
      windowWidth: window.innerWidth,
      localContentTypes: Object.assign(
        getDefaultContentTypes(this.images),
        this.contentTypes
      )
    };
  },
  mounted() {
    setTimeout(() => {
      if (this.images?.length) {
        this.localContentTypes.find(
          cType => cType.type === "images1"
        ).orderedImages = Object.assign([], this.images);

        this.localContentTypes.find(
          cType => cType.type === "images2"
        ).orderedImages = Object.assign([], this.images);

        const selectedImagesLength = this.localContentTypes.find(
          cType => cType.type === "images1"
        )?.selectedImages?.length;

        if (!selectedImagesLength) {
          this.localContentTypes.find(
            cType => cType.type === "images1"
          ).selectedImages = Object.assign([], this.images);
        }
      }
      this.$forceUpdate();
    }, 2000);
  },
  methods: {
    isMobile() {
      return this.windowWidth < this.defaultMobileBreakpoint;
    },
    selectImage({ image, id }) {
      const foundIndex = this.localContentTypes.findIndex(
        contentType => contentType.id === id
      );
      if (foundIndex === -1) return;

      if (!this.localContentTypes[foundIndex].selectedImages) {
        this.localContentTypes[foundIndex].selectedImages = [];
      }
      if (!this.localContentTypes[foundIndex].orderedImages) {
        this.localContentTypes[foundIndex].orderedImages = [];
      }

      if (
        !this.localContentTypes[foundIndex].selectedImages.find(
          i => i.url === image.url
        )
      ) {
        this.localContentTypes[foundIndex].selectedImages.push(image);
      } else {
        this.localContentTypes[
          foundIndex
        ].selectedImages = this.localContentTypes[
          foundIndex
        ].selectedImages.filter(i => i.url !== image.url);
      }
    },
    updateImages({ images, id }) {
      const foundIndex = this.localContentTypes.findIndex(
        contentType => contentType.id === id
      );
      if (foundIndex === -1) return;
      this.localContentTypes[foundIndex].orderedImages = images;
      this.localContentTypes[foundIndex].selectedImages = images.filter(i => {
        return this.localContentTypes[foundIndex].selectedImages.find(
          si => si.url === i.url
        );
      });
    },
    moveUp(index) {
      if (index > 0) {
        const temp = this.localContentTypes[index];
        this.localContentTypes[index] = this.localContentTypes[index - 1];
        this.localContentTypes[index - 1] = temp;
        this.$forceUpdate();
      }
    },
    moveDown(index) {
      if (index < this.localContentTypes.length - 1) {
        const temp = this.localContentTypes[index];
        this.localContentTypes[index] = this.localContentTypes[index + 1];
        this.localContentTypes[index + 1] = temp;
        this.$forceUpdate();
      }
    },
    saveCustomization(close = false) {
      this.$emit("triggerDialog", {
        close,
        save: true,
        contentTypes: this.localContentTypes.map(cType => {
          // don't save orderedImages, cause that is an array with all images of the news, only there for the drag and drop
          const { orderedImages, ...rest } = cType;
          return rest;
        })
      });
    }
  }
};
